"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TYPE2_UNVERIFIED_PHONE_MESSAGE = exports.TYPE2_PASSWORD_UPDATE_NOTICE_MESSAGE = exports.TYPE2_NO_EMAIL_MESSAGE = exports.TYPE2_ACCOUNT_VERIFICATION_MESSAGE = exports.TYPE1_SIGNUP_VERIFY_PHONE_MESSAGE = exports.TYPE1_FORGOT_PASSWORD_VERIFY_PHONE_MESSAGE = void 0; // LoginSignup Type1 Component

var TYPE1_SIGNUP_VERIFY_PHONE_MESSAGE = "You need to verify your phone to continue.";
exports.TYPE1_SIGNUP_VERIFY_PHONE_MESSAGE = TYPE1_SIGNUP_VERIFY_PHONE_MESSAGE;
var TYPE1_FORGOT_PASSWORD_VERIFY_PHONE_MESSAGE = "You need to verify your phone to continue."; // LoginSignup Type2 Component

exports.TYPE1_FORGOT_PASSWORD_VERIFY_PHONE_MESSAGE = TYPE1_FORGOT_PASSWORD_VERIFY_PHONE_MESSAGE;
var TYPE2_UNVERIFIED_PHONE_MESSAGE = "You need to verify your phone to continue.";
exports.TYPE2_UNVERIFIED_PHONE_MESSAGE = TYPE2_UNVERIFIED_PHONE_MESSAGE;
var TYPE2_NO_EMAIL_MESSAGE = "You need to add an email to your account to continue.";
exports.TYPE2_NO_EMAIL_MESSAGE = TYPE2_NO_EMAIL_MESSAGE;
var TYPE2_ACCOUNT_VERIFICATION_MESSAGE = "Before we continue, you'll need to verify your email/phone. We've sent a pincode to the information entered.";
exports.TYPE2_ACCOUNT_VERIFICATION_MESSAGE = TYPE2_ACCOUNT_VERIFICATION_MESSAGE;
var TYPE2_PASSWORD_UPDATE_NOTICE_MESSAGE = "You need to update your password to continue.";
exports.TYPE2_PASSWORD_UPDATE_NOTICE_MESSAGE = TYPE2_PASSWORD_UPDATE_NOTICE_MESSAGE;
var _default = {
  TYPE1_SIGNUP_VERIFY_PHONE_MESSAGE: TYPE1_SIGNUP_VERIFY_PHONE_MESSAGE,
  TYPE1_FORGOT_PASSWORD_VERIFY_PHONE_MESSAGE: TYPE1_FORGOT_PASSWORD_VERIFY_PHONE_MESSAGE,
  TYPE2_UNVERIFIED_PHONE_MESSAGE: TYPE2_UNVERIFIED_PHONE_MESSAGE,
  TYPE2_NO_EMAIL_MESSAGE: TYPE2_NO_EMAIL_MESSAGE,
  TYPE2_ACCOUNT_VERIFICATION_MESSAGE: TYPE2_ACCOUNT_VERIFICATION_MESSAGE,
  TYPE2_PASSWORD_UPDATE_NOTICE_MESSAGE: TYPE2_PASSWORD_UPDATE_NOTICE_MESSAGE
};
exports["default"] = _default;